import papaParse from 'papaparse';

export const convertToCsv = (formattedExportData: papaParse.UnparseObject<unknown>) =>
  papaParse.unparse(formattedExportData, {
    escapeFormulae: true,
    quotes: true,
  });
